export default "__VITE_ASSET__D4n23IO3__"